import './App.css';
import Header from './components/Header/Header';
import Router from './components/Router/Router';
import Footer from './components/Footer/Footer';
import { useEffect, useState } from 'react';

function App() {
  const [isDarkMode, setIsDarkMode] = useState(window.matchMedia('(prefers-color-scheme: dark)').matches);
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e) => setIsDarkMode(e.matches);
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  useEffect(() => {
    const rootElement = document.getElementById("root");
    if (rootElement){
      if (isDarkMode) {
        rootElement.classList.add("dark-mode");
        document.body.classList.add("dark-mode");
      }
      else {
        rootElement.classList.remove("dark-mode");
        document.body.classList.remove("dark-mode");
      }
    }
  }, [isDarkMode])

  return (
    <div id="App">
      <Header />
      <main>
          <Router />
      </main>
      <Footer />
    </div>
  );
}

export default App;
